/* eslint no-debugger: 0 */
export default class CustomSlider {

  constructor() {
    this.slides = window.opeImages
    this.current = 0
    this.selector = document.querySelector('#operations-slider')
    this.autoplay = true
    this.delay = 4000 //ms
    this.cache = {full:{}, thumbnails: []}
    if (this.selector) {
      this.load()
    }
  }

  load() {
    const shown = this.selector.querySelector('.slider-shown')
    const remaining = this.selector.querySelectorAll('.slider-remaining .slide a')
    this.elements = {
      mainSlide: shown,
      remaining: {
        0: remaining[0],
        1: remaining[1],
      },
      controls: this.selector.querySelectorAll('.slider-remaining [data-action]'),
      display: this.selector.querySelector('.slider-remaining .controls .dots'),
    }
    this.setListeners()
    this.updateDisplay()

    if (this.autoplay) {
      this.startAutoplay()
    }

  }

  setListeners() {
    for (let i = 0; i < this.elements.controls.length; i++) {
      this.elements.controls[i].addEventListener('click', function(e)  {
        e.preventDefault()
        const action = e.currentTarget.getAttribute('data-action')
        const options = e.currentTarget.dataset

        if (typeof this[action] === 'function') {
          this[action](options)
        }
      }.bind(this))
    }
  }

  updateDisplay() {
    this.elements.display.innerHTML = `${this.current + 1} / ${this.slides.length}`
  }

  next(attributes = {}) {
    const options = {shift: 1, ...attributes}
    const shift = parseInt(options.shift, 10)
    this.current = this.current + shift > (this.slides.length - 1) ? shift - 1 : this.current + shift
    this.replace()
    if (this.autoplay) {
      this.startAutoplay()
    }
  }

  prev() {
    this.current = this.current - 1 < 0 ? this.slides.length - 1 : this.current - 1
    this.replace()
  }

  pause() {
    this.autoplay = !this.autoplay

    if (!this.autoplay) {
      clearTimeout(this.autoplayInterval)
    } else {
      this.startAutoplay()
    }
    this.togglePauseButton()
  }

  replace() {
    const current = this.slides[this.current]
    this.replaceMain(this.buildMain(current))

   this.buildRemainings()

    this.updateDisplay()
  }

  buildMain(image) {
    if (this.cache.full[image.id]) {
      return this.cache.full[image.id]
    }
    const img = document.createElement('img')
    img.src = image.sizes.large
    let tpl = `
            <h3>${image.caption}</h3>
            <p>${image.description}</p>
          `
    const caption = document.createElement('div')
    caption.classList.add('caption')
    caption.innerHTML = tpl
    const div = document.createElement('div')
    div.classList.add('slide')
    div.appendChild(img)
    div.appendChild(caption)

    this.cache.full[image.id] = div
    return div
  }

  remainingCache() {
    const curr = this.current

    const thumbs = [this.getSlide(1), this.getSlide(2)].map(image => {
      const img = document.createElement('img')
      img.src = image.sizes.thumbnail
      img.setAttribute('data-image', true)
      img.alt = image.alt

      return {element: img, data: image}
    })

    this.cache.thumbnails[curr] = thumbs
  }
  buildRemainings() {
    this.remainingCache()

    this.setRemaining(this.elements.remaining[0], this.cache.thumbnails[this.current][0])
    this.setRemaining(this.elements.remaining[1], this.cache.thumbnails[this.current][1])
  }

  setRemaining(node, elt) {
    node.removeChild(node.querySelector('img'))
    node.appendChild(elt.element)
    node.setAttribute('href', elt.data.url)
  }

  replaceMain(el) {
    this.elements.mainSlide.innerHTML = ''
    this.elements.mainSlide.appendChild(el)
  }

  getSlide(shift = 0) {
    const pos = (this.current + shift) % this.slides.length
    const slide = this.slides[pos]
    return slide
  }

  startAutoplay() {
    if (this.autoplayInterval) {
      clearTimeout(this.autoplayInterval)
    }
    this.autoplayInterval = setTimeout(() => {
      this.next()
    }, this.delay)
  }

  togglePauseButton() {
    const btn = this.elements.controls[3]
    const playing = btn.querySelector('.playing')
    const pausing = btn.querySelector('.pausing')

    if (!this.autoplay) {
      playing.style.display = 'none'
      pausing.style.display = 'inline'
    } else {
      playing.style.display = 'inline'
      pausing.style.display = 'none'
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/autoload/CustomSlider.js